import React, { useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { ExportType } from '../../types/export'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  .modal-content {
    background: ${(props) => props.theme.bgLight || '#2a2a2a'};
    color: ${(props) => props.theme.textLight || '#fff'};
  }

  .modal-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    .modal-title {
      color: ${(props) => props.theme.textLight || '#fff'};
    }

    .btn-close {
      filter: brightness(0) invert(1);
    }
  }

  .modal-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
`

const StyledFormCheck = styled(Form.Check)`
  margin-bottom: 1rem;

  .form-check-input {
    background-color: transparent;
    border-color: rgba(255, 255, 255, 0.2);

    &:checked {
      background-color: ${(props) => props.theme.primary || '#0d6efd'};
      border-color: ${(props) => props.theme.primary || '#0d6efd'};
    }
  }

  .form-check-label {
    color: ${(props) => props.theme.textLight || '#fff'};
  }
`

interface ExportTypeDialogProps {
  show: boolean
  onHide: () => void
  onConfirm: (selectedTypes: ExportType[]) => void
}

const ExportTypeDialog: React.FC<ExportTypeDialogProps> = ({ show, onHide, onConfirm }) => {
  const [selectedTypes, setSelectedTypes] = useState<ExportType[]>([])
  const allowModelExport =
    String(process.env.REACT_APP_ALLOW_MODEL_EXPORT || '')
      .trim()
      .toLowerCase() === 'true'

  const handleTypeToggle = (type: ExportType) => {
    setSelectedTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    )
  }

  const handleConfirm = () => {
    onConfirm(selectedTypes)
    setSelectedTypes([]) // Reset selection after confirming
    onHide()
  }

  return (
    <StyledModal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Select Export Types</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {(['DATASET', 'MODEL'] as ExportType[]).map((type) => (
            <StyledFormCheck
              key={type}
              disabled={type === 'MODEL' && !allowModelExport}
              type="checkbox"
              id={`export-type-${type}`}
              label={
                type.charAt(0) +
                type.slice(1).toLowerCase() +
                (type === 'MODEL' && !allowModelExport
                  ? ' (Contact AgileView AI to request access)'
                  : '')
              }
              checked={selectedTypes.includes(type)}
              onChange={() => handleTypeToggle(type)}
            />
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm} disabled={selectedTypes.length === 0}>
          Create Export
        </Button>
      </Modal.Footer>
    </StyledModal>
  )
}

export default ExportTypeDialog
